export interface ErrorMessage {
    ErrCode?: number;
    ErrMessage?: string;
    ErrMessageID?: string;
    ErrType?: number;
    UniqueErrorCode?: number;
}